exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.grouped[data-v-1cb5e015] {\n  padding-top: 65px;\n  margin-top: -65px;\n}\n", "", {"version":3,"sources":["C:/IBE_Agent1/_work/11/s/src/Nps.Frontier.Web/VueApps/Shared/Components/errorList.vue"],"names":[],"mappings":";AAAA;EACE,kBAAkB;EAClB,kBAAkB;CACnB","file":"errorList.vue","sourcesContent":[".grouped {\n  padding-top: 65px;\n  margin-top: -65px;\n}\n"],"sourceRoot":""}]);

// exports
